export const RouterConfig = {
    MAIN: "/",
    CATALOG: "/catalog",
    CATALOG_ALL: "/catalog/all-cities/all",
    DILLERS: "/dillers",
    PRODUCT: "/product",
    CREATE_OFFER: "/post",
    INSURANCE: "/insurance",
    AUTHORS: "/authors",
    ANALYTICS: "/analytics",
    BLOG: "/blog",
    COMPARE: "/compare",
    CONTACTS: "/contacts",
    FAVORITES: "/saved",
    HISTORY: "/history",
    HISTORY_MY_REPORTS: "/history/my",
    HISTORY_REPORT: "/history/report",
    MY_ADS: "/my-ads",
    MY_ADS_EDIT: "/my-ads/edit",
    VIEWED_ADS: "/viewed",
    JOB: "/job",
    MARKETPLACES: "/marketplaces",
    PAYMENT_PAGE: "/payment",
    PROPERTY: "/property",
    PROFILE: "/profile",
    PROFILE_COMPANY: "/profile/company",
    PROFILE_DESCRIPTION: "/profile/description",
    VERIFICATION: "/verification",
    RESTORE_PASSWORD: "/restore-password",
    PRIVACY_POLICY: "/docs/privacy-policy",
    TERMS_OF_USE: "/docs/terms_of_use_LIKVI.pdf",
    RULES: "/rules",
    PERSONAL_DATA_POLITICS: "/docs/personal_data_politics",
    GENERATOR_DKP: "/contract-generator",
    MOBILE_APP: "/mobile-app",
    SUPPORT: "/support"
};